import { gql } from 'graphql-request'

export const createTimeTracking = gql`
  mutation CreateTimeTracking(
    $user_id: ID
    $date: Date!
    $client: String
    $duration: Float!
    $is_night_work: Boolean!
    $start_night: String
    $end_night: String
    $is_emergency_service: Boolean!
    $comment: String
    $drive: Float!
  ) {
    createTimeTracking(
      user_id: $user_id
      date: $date
      client: $client
      duration: $duration
      is_night_work: $is_night_work
      start_night: $start_night
      end_night: $end_night
      is_emergency_service: $is_emergency_service
      comment: $comment
      drive: $drive
    ) {
      id
      date
      client
      duration
      comment
      is_night_work
      start_night
      end_night
      is_emergency_service
    }
  }
`

export const deleteTimeTracking = gql`
  mutation DeleteTimeTracking(
    $id: ID!) {
    deleteTimeTracking(
      id: $id)
  }
`

export const createSickTracking = gql`
  mutation CreateSickTracking(
    $user_id: ID
    $start_date: Date!,
    $end_date: Date!,
    $comment: String,
    $file: Upload
  ) {
    createSickTracking(
      user_id: $user_id
      start_date: $start_date,
      end_date: $end_date,
      comment: $comment,
      file: $file,
    ) {
      id
      start_date
      end_date
      sick_days
      file_link
      comment
    }
  }
`

export const createOvertimeTracking = gql`
  mutation CreateOvertimeTracking(
    $user_id: ID
    $start_date: Date!
    $end_date: Date!
    $substitute_id: ID
    $comment: String
  ) {
    createOvertimeTracking(
      user_id: $user_id
      start_date: $start_date
      end_date: $end_date
      substitute_id: $substitute_id
      comment: $comment
    ) {
      id
      user {
        id
        full_name
      }
      substitute {
        id
        full_name
      }
      start_date
      end_date
      overtime_days
      status
      comment
    }
  }
`

export const createHolidayTracking = gql`
  mutation CreateHolidayTracking(
    $user_id: ID
    $start_date: Date!
    $end_date: Date!
    $substitute_id: ID
    $comment: String
  ) {
    createHolidayTracking(
      user_id: $user_id
      start_date: $start_date
      end_date: $end_date
      substitute_id: $substitute_id
      comment: $comment
    ) {
      id
      user {
        id
        full_name
      }
      substitute {
        id
        full_name
      }
      start_date
      end_date
      holiday_days
      status
      comment
    }
  }
`

export const updatePassword = gql`
  mutation UpdatePassword($old_password: String!, $new_password: String! ) {
      updatePassword(old_password: $old_password, new_password: $new_password) {
        id
        token
      
      }
    }
`

export const closeMonthUser = gql`
  mutation CloseMonthUser(
      $month: Int!,
      $year: Int!,
      $comment: String,
      $user_id: ID) {
      closeMonthUser(
        month: $month,
        year: $year,
        comment: $comment,
        user_id: $user_id) {
        id
      }
    }
`

export const deleteClosedMonth = gql`
  mutation DeleteClosedMonth(
  $user_id: ID!, 
  $month: Int!, 
  $year: Int!) {
    deleteClosedMonth(
    user_id: $user_id, 
    month: $month, 
    year: $year)
  }
`

export const reopenMonthPayroll = gql`
  mutation ReopenMonthPayroll(
  $userId: ID!, 
  $month: Int!, 
  $year: Int!) {
    reopenMonthPayroll(
    userId: $userId, 
    month: $month, 
    year: $year)
  }
`

export const setPassword = gql`
  mutation SetPassword(
  $user_id: ID!, 
  $token: String!, 
  $password: String!) {
    setPassword(
      user_id: $user_id
      token: $token
      password: $password
    )
  }
`

export const CREATE_DEVICE_TOKEN = gql`
  mutation createDeviceToken($token: String!) {
      createDeviceToken(device_token: $token)
  }
`;

export const emergencyExistsQuery = gql`
  query EmergencyExists(
    $userId: ID, 
    $date: Date!) {
      emergencyExists(
        user_id: $userId, 
        date: $date)
  }
`;

export const toggleEmergencyMutation = gql`
  mutation ToggleEmergency(
    $userId: ID, 
    $date: Date!) {
      toggleEmergency(
        user_id: $userId, 
        date: $date)
  }
`;